import { abrePDF } from "../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import moment from "moment";

function DashboardVentasTabla() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // C3: modal de detalle de ventas por artículo
  const [modalDetalle, setModalDetalle] = useState(false);
  const toggleDetalle = () => setModalDetalle(!modalDetalle);
  const [detalleRows, setDetalleRows] = useState([]);
  const [detalleArticulo, setDetalleArticulo] = useState("");
  const [detalleLoading, setDetalleLoading] = useState(false);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalImporte, setTotalTotalImporte] = useState(0);
  const [totalTotalValorStock, setTotalTotalValorStock] = useState(0);
  const [lineas, setLineas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedArea, setSelectedArea] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      icon: "success",
      title: "Danos unos segundos....",
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}VentasTabla/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible

      setComments(array)

      let unicosLinea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLinea);

      let unicosArea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idArea === value.idArea)
      );
      setAreas(unicosArea);

      let can = allDisponible.map((c) => parseFloat(c.Cantidad));
      let TCan = can.reduce((t, cantidad, index) => t + cantidad, 0);
      setTotalTotalCantidad(TCan);

      let imp = allDisponible.map((c) => parseFloat(c.Importe));
      let Timp = imp.reduce((t, cajas, index) => t + cajas, 0);
      setTotalTotalImporte(Timp);

      let vs = allDisponible.map((c) => parseFloat(c.ValorStock || 0));
      let Tvs = vs.reduce((t, v) => t + v, 0);
      setTotalTotalValorStock(Tvs);

      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });


},[])

function BuscaInfo(){
  setComments([])
  setSelectedArea("")
  setSelectedLinea("")
  setCargando(true)
  axios
  .get(`${URL_DASHBOARDS}VentasTabla/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible

      setComments(array)

      let unicosLinea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLinea);

      let unicosArea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idArea === value.idArea)
      );
      setAreas(unicosArea);

      let can = allDisponible.map((c) => parseFloat(c.Cantidad));
      setTotalTotalCantidad(can.reduce((t, v) => t + v, 0));
      let imp = allDisponible.map((c) => parseFloat(c.Importe));
      setTotalTotalImporte(imp.reduce((t, v) => t + v, 0));
      let vs = allDisponible.map((c) => parseFloat(c.ValorStock || 0));
      setTotalTotalValorStock(vs.reduce((t, v) => t + v, 0));

      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
}



  // C3: abrir modal con el detalle de ventas de un artículo en el rango actual.
  // Derivamos la URL del endpoint articulosSurtidosDetalle a partir de
  // REACT_APP_URL_ARTICULOS_SURTIDOS (mismo API base).
  async function abrirDetalleArticulo(idArticulo, nombre) {
    const base = String(process.env.REACT_APP_URL_ARTICULOS_SURTIDOS || "").replace(
      /\/articulosSurtidos\/?$/,
      ""
    );
    setDetalleArticulo(nombre || "");
    setDetalleRows([]);
    setDetalleLoading(true);
    setModalDetalle(true);
    try {
      const res = await axios.get(
        `${base}/articulosSurtidosDetalle/${idArticulo}/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setDetalleRows(res.data || []);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar el detalle" });
    } finally {
      setDetalleLoading(false);
    }
  }

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedArea == 0 || selectedArea == a.idArea) &&
        (selectedLinea == 0 || selectedLinea == a.idLinea) 
      ) {
        return [
          a.Codigo,
          a.SKU || "",
          new Intl.NumberFormat("en-US").format(a.Cantidad),
          new Intl.NumberFormat("en-US").format(a.PendEmbarcar || 0),
          new Intl.NumberFormat("en-US").format(a.PendRecibir || 0),
          new Intl.NumberFormat("en-US").format(a.Stock || 0),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoUnitario || 0),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.ValorStock || 0),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.Importe),
          a.Area,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Reporte Ventas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        ["Nombre", "SKU", "Cantidad", "Pend. Embarcar", "Pend. Recibir", "Stock", "Costo Unit.", "Valor Stock", "Importe", "Almacen"],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    abrePDF(doc, `DashboardVentasTable.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedArea == 0 || selectedArea == a.idArea) &&
        (selectedLinea == 0 || selectedLinea == a.idLinea) 
      ) {
        return {
          Nombre: a.Codigo,
          SKU: a.SKU || "",
          Cantidad: a.Cantidad,
          PendEmbarcar: a.PendEmbarcar || 0,
          PendRecibir: a.PendRecibir || 0,
          Stock: a.Stock || 0,
          CostoUnitario: a.CostoUnitario || 0,
          ValorStock: a.ValorStock || 0,
          Importe: a.Importe,
          Almacen: a.Area,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoAjustesInventario";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAjustesInventario",
        sheetFilter: [
          "Nombre",
          "SKU",
          "Cantidad",
          "PendEmbarcar",
          "PendRecibir",
          "Stock",
          "CostoUnitario",
          "ValorStock",
          "Importe",
          "Almacen",
        ],
        sheetHeader: [
          "Nombre",
          "SKU",
          "Cantidad",
          "Pend. Embarcar",
          "Pend. Recibir",
          "Stock",
          "Costo Unit.",
          "Valor Stock",
          "Importe",
          "Almacen",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedArea == 0 || selectedArea == a.idArea) &&
        (selectedLinea == 0 || selectedLinea == a.idLinea) 
      ) {
      return [
        a.Codigo,
        a.SKU || "",
        new Intl.NumberFormat("en-US").format(a.Cantidad),
        new Intl.NumberFormat("en-US").format(a.PendEmbarcar || 0),
        new Intl.NumberFormat("en-US").format(a.PendRecibir || 0),
        new Intl.NumberFormat("en-US").format(a.Stock || 0),
        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoUnitario || 0),
        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.ValorStock || 0),
        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.Importe),
        a.Area,
      ];
    }
  });
  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });
  const doc = new jsPDF("landscape", "mm", "a4", true);
  var img = new Image();
  
  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 120, 10, 35, 18);
  doc.text(`Reporte Ventas`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
  doc.autoTable({
    head: [
      ["Nombre", "SKU", "Cantidad", "Pend. Embarcar", "Pend. Recibir", "Stock", "Costo Unit.", "Valor Stock", "Importe", "Almacen"],
    ],
    body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
    startY: 45,
  });

    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas",
          email: mailTo,
          fileName: "ReporteVentas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte de Ventas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }




  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "Codigo", sortable: true },
    { name: "Cantidad", field: "Cantidad", sortable: true },
    { name: "Pend. Embarcar", field: "PendEmbarcar", sortable: true },
    { name: "Pend. Recibir", field: "PendRecibir", sortable: true },
    { name: "Stock", field: "Stock", sortable: true },
    { name: "Costo Unit.", field: "CostoUnitario", sortable: true },
    { name: "Valor Stock", field: "ValorStock", sortable: true },
    { name: "Importe Vendido", field: "Importe", sortable: true },
    { name: "Almacen", field: "Area", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.Codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
          comment.Area.toLowerCase().includes(search.toLowerCase()) ||
          comment.Cantidad.toString().includes(search) ||
          comment.Importe.toString().includes(search)
      );
    }

    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea)
      );
    }

    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }
 

    setTotalItems(computedComments.length);

    //Sorting comments
    const camposNumericos = ["Importe", "Cantidad", "Stock"];
    if (
      sorting.field &&
      !camposNumericos.includes(sorting.field)
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || ""))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort(
        (a, b) => (parseFloat(a[sorting.field]) || 0) - (parseFloat(b[sorting.field]) || 0)
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort(
        (a, b) => (parseFloat(b[sorting.field]) || 0) - (parseFloat(a[sorting.field]) || 0)
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedArea,
    selectedLinea, 
  ]);

let totalCantidad = 0
let totalImporte = 0
 
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
            
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          {/* C3: modal con el detalle de ventas del artículo elegido */}
          <Modal size="xl" isOpen={modalDetalle} toggle={toggleDetalle}>
            <ModalHeader toggle={toggleDetalle}>
              <h4>Ventas de {detalleArticulo} — {selectedFechaInicio} → {selectedFechaFin}</h4>
            </ModalHeader>
            <ModalBody>
              {detalleLoading ? (
                <div align="center">Cargando…</div>
              ) : detalleRows.length === 0 ? (
                <div align="center">Sin movimientos en el rango.</div>
              ) : (
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Tipo</th>
                      <th>Nota</th>
                      <th>Pedido</th>
                      <th>Cliente</th>
                      <th>Vendedor</th>
                      <th>Área</th>
                      <th align="right">Cantidad</th>
                      <th align="right">Precio</th>
                      <th align="right">Desc %</th>
                      <th align="right">Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalleRows.map((d) => (
                      <tr
                        key={d._id}
                        style={d.pendiente ? { backgroundColor: "#fff3cd" } : undefined}
                      >
                        <td>{d.fecha ? String(d.fecha).slice(0, 10) : ""}</td>
                        <td>
                          {d.pendiente ? (
                            <span style={{ color: "#b8860b", fontWeight: 600 }}>Pend. surtir</span>
                          ) : (
                            "Vendido"
                          )}
                        </td>
                        <td>{d.surtido}</td>
                        <td>{d.pedido || ""}</td>
                        <td>{d.cliente}</td>
                        <td>{d.vendedor}</td>
                        <td>{d.area}</td>
                        <td align="right">{new Intl.NumberFormat("en-US").format(d.cantidad)}</td>
                        <td align="right">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(d.precio)}</td>
                        <td align="right">{d.descuento ? `${Number(d.descuento).toFixed(2)}%` : "-"}</td>
                        <td align="right">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(d.importe)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={7} className="negrita" align="right">Total</td>
                      <td align="right" className="negrita">
                        {new Intl.NumberFormat("en-US").format(
                          detalleRows.reduce((t, x) => t + Number(x.cantidad || 0), 0)
                        )}
                      </td>
                      <td colSpan={2}></td>
                      <td align="right" className="negrita">
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(
                          detalleRows.reduce((t, x) => t + Number(x.importe || 0), 0)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </ModalBody>
          </Modal>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ventas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" 
              onClick={enviaMail}
              >
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Dashboard Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
        <Col md={2}>
            <Label className="mr-sm-2">Fecha Inicio</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              required
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
              }}
            />
          </Col>
          <Col md={2}>
            <Label className="mr-sm-2">Fecha Fin</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              required
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
              }}
            />
          </Col>
          <Col md={2}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color="info"
            >
              Actualizar
            </Button>
          </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Lineas</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedLinea}
                required
                onChange={(e) => {
                  setSelectedLinea(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {lineas
                  .sort((a, b) => (a.Linea > b.Linea ? 1 : -1))
                  .map((a) => {
                    return <option value={a.idLinea}>{a.Linea}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">Almacen</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedArea}
                required
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {areas
                  .sort((a, b) => (a.Area > b.Area ? 1 : -1))
                  .map((a) => {
                    return <option value={a.idArea}>{a.Area}</option>;
                  })}
              </Input>
            </Col>

        </Row> 
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                totalCantidad = totalCantidad + parseFloat(a.Cantidad);
                totalImporte = totalImporte + parseFloat(a.Importe);
                  return (
                    <tr>
                      <td>{a.SKU || ""}</td>
                      {/* <td style={{ maxWidth: "160px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "help" }}>
                        <span id={`nombre-${a.idArticulo}`}>{a.Codigo}</span>
                        <UncontrolledTooltip placement="top" target={`nombre-${a.idArticulo}`}>
                          {a.Codigo}
                        </UncontrolledTooltip>
                      </td> */}
                      <td>{a.Codigo}</td>
                      <td>
                        {Number(a.Cantidad) > 0 ? (
                          <Button
                            size="sm"
                            color="link"
                            style={{
                              padding: 0,
                              color: "#0d6efd",
                              textDecoration: "underline",
                              fontWeight: 600,
                            }}
                            onClick={() => abrirDetalleArticulo(a.idArticulo, `${a.SKU || ""} ${a.Codigo || ""}`)}
                          >
                            {new Intl.NumberFormat("en-US").format(a.Cantidad)}
                          </Button>
                        ) : (
                          new Intl.NumberFormat("en-US").format(a.Cantidad)
                        )}
                      </td>
                      <td>{new Intl.NumberFormat("en-US").format(a.PendEmbarcar || 0)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.PendRecibir || 0)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.Stock || 0)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoUnitario || 0)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.ValorStock || 0)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.Importe)}</td>
                      <td>{a.Area}</td>

                    </tr>
                  );
              })}
              <tr>
                <td className="negrita">Total</td>
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalValorStock)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalImporte)}</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      
      {loader}
    </>
  );
}

export default DashboardVentasTabla;
